export class Main {
    opts = {
        heroInDelay : 350
    }

    win: any;

    resizeTimer: any = 0; // Used for resizing hero

    public constructor() {
        this.win = window as any;
    }

    public init() {
        document.documentElement.setAttribute("data-agent", navigator.userAgent);
        this.win.SiteSelector.init();
        this.win.Notifications.init();
        this.win.AnchorMenu.init();

        let
            $win        = $(this.win),
            $html       = $('html'),
            $body       = $('body');

        (!("ontouchstart" in document.documentElement)) ? $html.addClass('no-touch') : $html.addClass('touch');

        if (this.win.Helpers.isMobileSafari()) {
            $html.addClass('mobile-safari');
        }

        // Detect all kinds of stupidity
        if (this.win.Helpers.isMicrosoftUser()) {
            $html
                .addClass('ie-' + this.win.Helpers.getInternetExplorerVersion())
                .addClass('ms-user')
                .removeClass('touch').addClass('no-touch'); // can't predict touch screen on this.wins machines;

            var ieVersion = parseInt(this.win.Helpers.getInternetExplorerVersion(), 10);

            if (ieVersion != 0 && ieVersion < 11) {
                $html.addClass('lt-ie11');
            }
        }

        // Set transitions class to enable transitions
        $body.addClass('transitions');

        this.initHubSpotCookie();
        this.initHero();
        this.initAnchorLinks();
        this.initStickyFooter();
        this.initColumns();
        this.initHubSpotForms();
        this.initRippleEffect();

        // Disable transitions while resizing
        var resizeTimer;
        $win.on('resize', () => {

            this.updateHeroHeight();

            $body.removeClass('transitions');
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                $body.addClass('transitions');
            }, 750);
        });
    }

    initHero(){
        let $hero = $('#hero'),
            startTime = Date.now(),
            $heroImageBackground = $('.hero.image-background');

        if ($hero.length) {

            // Set loaded class on hero when image is loaded
            $heroImageBackground.each((i, e) => {
                var $parent = $(e);
                (window as any).Helpers.onImagesLoaded($parent.find('.inner-img')).then(() => {

                    var curTime = Date.now();
                    if ((curTime - startTime) > this.opts.heroInDelay) {
                        // The hero imaged load time exceeds the set delay => show immediately
                        $parent.addClass('loaded');
                        this.updateHeroHeight();
                    } else {
                        // The hero image loaded mad fast => delay it a bit
                        setTimeout(() => {
                            $parent.addClass('loaded');
                            this.updateHeroHeight();
                        }, this.opts.heroInDelay - (curTime - startTime));
                    }
                });

                $(e).addClass('initiated');
            });

            if (!$heroImageBackground.length) {
                $hero.addClass('initiated');
                setTimeout(() => {
                    $hero.addClass('loaded');
                }, this.opts.heroInDelay);
            }
        }

    }

    initAnchorLinks() {
        var anchorMenu = $(".anchor-menu-wrapper");
        var anchorMenuOffset = anchorMenu.length > 0 ? anchorMenu.height() : 0;

        $('main .anchor-link').click(function (event) {
            var target = $(($(this)[0] as any).hash);
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - anchorMenuOffset
                }, 650);
            }
        });
    }

    initHubSpotCookie() {
        var hsCookie = this.win.ZO.hsCookie.getInstance();
        hsCookie.initOneTrustForHubSpot();

        this.win.addEventListener('OneTrustGroupsUpdated', e => {
            hsCookie.initOneTrustForHubSpot();
        }, false);
    }

    initStickyFooter() {
        var $body = $('body');

        if ($('.sticky-footer').length) {
            if (!$body.hasClass("sticky-footer-hide")) {
                // Use has already set up the selector, show notifications normally
                $body.addClass('sticky-footer-enabled');
            }
        }
    }

    initColumns() {
        // Strip away empty columns if there are any at the end of the column blocks
        $('.column-block').each(function(){
            if ($(this).find('.col:last').hasClass('empty')) {
                $(this).find('.col:last').remove();
            }
        });
    }

    updateHeroHeight() {
        var $hero       = $('#hero'),
            oldWinWidth = $('#hero').data('oldWidth') ? $('#hero').data('oldWidth') : 0; // Only resize if win width changed (if on mobile)

        if ($hero.length && this.win.Helpers.mobilecheck() && $(this.win).width() < 480) {

            // Set static height on touch devices to prevent jump when viewport resizes due to mobile browser UI
            if ($hero.length && $hero.hasClass('image-background') && $(this.win).width() != oldWinWidth) {
                //$hero.removeAttr('style');
                $hero.css('height', '');

                clearTimeout(this.resizeTimer);

                var heroHeight = $hero.height();
                //var heroHeight = $(this.win).height() - $('.navbar').height();

                this.resizeTimer = setTimeout(() => {
                    $hero
                        .css('height', heroHeight + 'px')
                        .data('oldWidth', $(this.win).width());

                }, 1000);

                $hero.data('oldWidth', $(this.win).width());
            }
            
        } else if ($hero.length && this.win.Helpers.mobilecheck()) {
            $hero.css('height', '');
            //$hero.removeAttr('style');
        }
    }

    initHubSpotForms() {

        var self = this;

        // General forms and subscribe forms

        ($('#footer-subscribe-form') as any).hsFormSharingan({
            callback    : function(){
                self.defaultFormCallback($(this), false);

                // Scroll to form on submit
                $(this).submit(function(){
                    setTimeout(() => {
                        var offset  = $('.navbar').height();
                        this.win.Helpers.scrollTo('.footer--primary', -offset);
                    }, 500);

                });
            },
            embedded    : true
        });

        if ($('.hubspot-form-container').length) {

            ($('.hubspot-form-container') as any).hsFormSharingan({
                callback    : function(){
                    self.defaultFormCallback($(this), false);

                    $(this).submit(function(){

                        var $form = $(this);
                        setTimeout(() => {
                            var errors  = $form.find('.hs-input.error, .hs-input.invalid').length,
                                offset  = $('.navbar').height();

                            if (errors > 0) {
                                this.win.Helpers.scrollTo('#' + $form.attr('id'), -offset);
                            }else {
                                this.win.Helpers.scrollTo('body', -offset);
                            }
                        }, 500);

                    });
                },
                embedded    : true
            });
        }
        
        //if ($('.login-block').length) {
        //    $('.login-block form').each(function(){
        //        self.defaultFormCallback($(this), true);
        //    });
        //}

        $('.campaign-page .cta-block').each(function(){

            ($(this).find('.text-container') as any).hsFormSharingan({
                callback    : function(){

                    var parentID = $(this).parent().attr('id');

                    self.defaultFormCallback($(this), false);

                    $(this).submit(function() {
                        var $form = $(this);
                        setTimeout(() => {
                            var errors = $form.find('.hs-input.error, .hs-input.invalid').length,
                                offset = $('.navbar').height();

                            //if (errors > 0) {
                                this.win.Helpers.scrollTo('#' + parentID, -offset);
                            //} else {
                            //    this.win.Helpers.scrollTo('body', -offset);
                            //}
                        }, 500);
                    });
                },
                embedded: true
            });
        });
        //$('.hs_cos_wrapper_type_form, .hs_cos_wrapper_type_blog_subscribe').hsFormSharingan({
        //    callback: self.defaultFormCallback
        //});
    }

    initRippleEffect() {
        $(document)
            .on(
                'mousedown touchstart',
                '.button, .hs-button',
                event => event.target.classList.add('active')
            )
            .on(
                'mouseup touchend mouseleave',
                '.button, .hs-button',
                event => event.target.classList.remove('active')
            );
    }

    initCustomFormUI(formEl, enableFloatedLabels) {
        var parent = formEl || $('body');

        enableFloatedLabels = enableFloatedLabels !== undefined ? enableFloatedLabels : true;

        if (formEl.parent().hasClass('hubspot-form-container')) {
            enableFloatedLabels = false;
        }

        // Select dropdowns
        parent.find('select').each(function () {
            if (!$(this).parent().hasClass('Select')) {
                $(this).parent().addClass('Select');
            }
        });

        if (formEl !== undefined && enableFloatedLabels) {
            // Floated label inputs
            ($(formEl) as any).hsFloatedLabels({
                enablePlaceholder   : true
            });
        }

    }

    defaultFormCallback(formEl, enableFloatedLabels) {
        // Form has initialized

        if (formEl) {

            this.initCustomFormUI(formEl, enableFloatedLabels);

            // Add placeholders, and hide labels
            //if($('html').hasClass('placeholder')) {
            //    ZO.helper.placeholderizer(formEl, false);
            //}

            if (!this.win.Helpers.mobilecheck()) {
                //autosize(formEl.find('textarea'));
            }

            $(document).trigger('content:changed');
        }
    }
};